import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XrSession, PerformanceFrame } from '../../../../models/session.model';

@Component({
  selector: 'app-session-telemetry-panel',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex-1 overflow-y-auto p-4 space-y-4 custom-scrollbar">
      <div *ngIf="!session?.performance_snapshot" class="text-center py-12 text-gray-500 text-sm">
        No hay datos de rendimiento en esta sesión.
      </div>

      <div *ngIf="session?.performance_snapshot" class="space-y-3">
        <!-- Real FPS -->
        <div class="bg-black border border-zaxis-border rounded-none p-4 border border-zaxis-border">
          <div class="flex justify-between items-center">
            <span class="text-xs text-gray-400 uppercase tracking-wider font-bold">Promedio FPS</span>
            <span class="text-2xl font-bold"
                  [class]="averageFps >= 60 ? 'text-green-400' : averageFps >= 30 ? 'text-yellow-400' : 'text-red-400'">
              {{ averageFps | number:'1.1-1' }}
            </span>
          </div>
          <div class="w-full h-1.5 bg-black/30 rounded-none mt-2 overflow-hidden">
            <div class="h-full rounded-none transition-all"
                 [class]="averageFps >= 60 ? 'bg-green-400' : averageFps >= 30 ? 'bg-yellow-400' : 'bg-red-400'"
                 [style.width.%]="(averageFps / currentRefreshRate) * 100"></div>
          </div>
        </div>

        <!-- Display Refresh Rate -->
        <div class="bg-black border border-zaxis-border rounded-none p-4 border border-zaxis-border">
          <div class="flex justify-between items-center">
            <span class="text-xs text-gray-400 uppercase tracking-wider font-bold">Display Refresh Rate</span>
            <span class="text-lg font-mono font-bold tracking-widest text-white uppercase">{{ currentRefreshRate | number:'1.1-1' }} Hz</span>
          </div>
        </div>

        <!-- CPU Level & Cycle Time -->
        <div class="bg-black border border-zaxis-border rounded-none p-4 border border-zaxis-border space-y-3">
          <div class="flex justify-between items-center">
            <span class="text-xs text-gray-400 uppercase tracking-wider font-bold">CPU Level</span>
            <span class="text-lg font-mono font-bold tracking-widest text-white uppercase">{{ currentCpuLevel }} <span class="text-xs text-gray-500">/ 4</span></span>
          </div>
          <div class="w-full h-1.5 bg-black/30 rounded-none mt-2 overflow-hidden">
            <div class="h-full bg-blue-400 rounded-none transition-all"
                 [style.width.%]="(currentCpuLevel / 4) * 100"></div>
          </div>
          <div class="flex justify-between items-center pt-2 border-t border-zaxis-border">
            <span class="text-[10px] text-gray-500 font-bold uppercase tracking-wider">Cycle Time</span>
            <span class="text-xs font-mono text-gray-300">{{ currentPerformanceFrame?.cpuCycleTimeMs || 0 | number:'1.2-2' }} ms</span>
          </div>
        </div>

        <!-- GPU Level & Cycle Time -->
        <div class="bg-black border border-zaxis-border rounded-none p-4 border border-zaxis-border space-y-3">
          <div class="flex justify-between items-center">
            <span class="text-xs text-gray-400 uppercase tracking-wider font-bold">GPU Level</span>
            <span class="text-lg font-mono font-bold tracking-widest text-white uppercase">{{ currentGpuLevel }} <span class="text-xs text-gray-500">/ 4</span></span>
          </div>
          <div class="w-full h-1.5 bg-black/30 rounded-none mt-2 overflow-hidden">
            <div class="h-full bg-purple-400 rounded-none transition-all"
                 [style.width.%]="(currentGpuLevel / 4) * 100"></div>
          </div>
          <div class="flex justify-between items-center pt-2 border-t border-zaxis-border">
            <span class="text-[10px] text-gray-500 font-bold uppercase tracking-wider">Cycle Time</span>
            <span class="text-xs font-mono text-gray-300">{{ currentPerformanceFrame?.gpuCycleTimeMs || 0 | number:'1.2-2' }} ms</span>
          </div>
        </div>
      </div>
    </div>
  `
})
export class SessionTelemetryPanelComponent {
  @Input() session?: XrSession | null;
  @Input() averageFps: number = 0;
  @Input() currentRefreshRate: number = 72;
  @Input() currentCpuLevel: number = 0;
  @Input() currentGpuLevel: number = 0;
  @Input() currentPerformanceFrame: PerformanceFrame | null = null;
}
